import {
  TextField,
  Box,
  Chip,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import React, { useState } from "react";
import ConfirmationWithDescription from "src/components/ConfirmationWithDescription";
import DescriptionSeeMore from "./DescriptionSeeMore";

const SomeThingElseExercisesUI = ({
  addArray,
  setaddArray,
  setModalChangeExe,
  mainindex,
  isWorkoutCompleted,
  setIsWorkoutCompleted,
  practiceType,
  handleSubmit,
}) => {
  const [openExerciseAlert, setOpenExerciseAlert] = useState(false);
  const [exerIndex, setExerIndex] = useState("");

  const handleChangeComplete = (e, index) => {
    const { checked } = e.target;
    const list = [...addArray];
    if (!checked && isWorkoutCompleted) {
      setExerIndex(index);
      setOpenExerciseAlert(true);
      return;
    }
    list[index]["is_completed"] = checked;
    setModalChangeExe(true);
    setaddArray(list);
    if (checked) {
      handleSubmit(true, true);
    }
  };

  const handleAgreeInExerciseSet = () => {
    const list = [...addArray];
    list[exerIndex]["is_completed"] = false;
    setIsWorkoutCompleted(false);
    setModalChangeExe(true);
    setOpenExerciseAlert(false);
    setaddArray(list);
  };

  const handleChangeDes = (e, index) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[index][name] = value;
    setaddArray(list);
    setModalChangeExe(true);
  };

  return (
    <div className="my-2">
      <ConfirmationWithDescription
        open={openExerciseAlert}
        setOpen={setOpenExerciseAlert}
        title={"Are you sure you want to take this action?"}
        descriotion={`If you uncheck, your points or coins allocated for this ${practiceType} will be deducted.`}
        isJustForOk={false}
        handleAgree={handleAgreeInExerciseSet}
      />
      <div className="characters mt-2">
        <div
          style={{
            width: "100%",
            padding: "1px",
            position: "relative",
          }}
        >
          <div
            className="d-flex my-1 workout-set-card w-100"
            style={{
              width: "100%",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",
              }}
            >
              <div className="row">
                <div
                  className={`col-sm-12 ${"col-md-7"} col-lg-6 d-flex align-items-center`}
                >
                  {addArray[mainindex]?.is_modified && (
                    <span
                      style={{
                        position: "absolute",
                        top: "-11px",
                        justifyContent: "center",
                        zIndex: "1",
                        left: "-38px",
                        transform: "rotate(-53deg)",
                      }}
                    >
                      <Chip
                        label={"Modified"}
                        variant="contained"
                        color={"error"}
                        sx={{
                          fontSize: "10px",
                          height: "auto",
                          width: "auto",
                        }}
                      />
                    </span>
                  )}
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    placeholder="Name"
                    value={
                      addArray[mainindex]?.title
                        ? addArray[mainindex]?.title
                        : ""
                    }
                    name="title"
                    onChange={(e) => handleChangeDes(e, mainindex)}
                    InputLabelProps={{
                      className: "textfiels-input-label",
                      shrink: true,
                      style: { fontSize: "14px" },
                    }}
                    multiline
                    rows={addArray[mainindex]?.title ? null : 1}
                    label="Name"
                    InputProps={{
                      className: "textfiels-input-value",
                      style: {
                        fontSize: "13px",
                        paddingLeft: "6px",
                      },

                      inputProps: {
                        readOnly: true,
                      },
                    }}
                    sx={{
                      borderRadius: "5px",

                      fontSize: "13px",
                      width: "100%",
                    }}
                  />
                </div>
              </div>
              {addArray[mainindex]?.description && (
                <DescriptionSeeMore
                  description={addArray[mainindex]?.description}
                />
              )}
              <div className="d-flex justify-content-end mt-3">
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{ p: "3px" }}
                        checked={addArray[mainindex]?.is_completed}
                        onChange={(e) => handleChangeComplete(e, mainindex)}
                      />
                    }
                    label="Mark as Complete"
                  />
                </FormGroup>
              </div>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SomeThingElseExercisesUI;
